import { Cart } from '@lambda/commons/apis/shopify/types/storefront';
import { trackEvent } from './vendor/segment/segment';
import { SegmentEvent } from './events';
import { CartEventProperties } from './types';
import { makeProductProperties } from './trackProduct';
import settings from '@/settings';
import { logger } from '../logger';

const getCartId = (cart: Cart): string => {
  try {
    return cart.id.split('/').slice(-1)[0];
  } catch (e: any) {
    return cart.id;
  }
};

const makeCartProperties = (cart: Cart): CartEventProperties => ({
  store: settings.store,
  cart_id: getCartId(cart),
  products: cart.lines.edges.map((e) =>
    makeProductProperties({
      variant: e.node.merchandise,
      variantAttributes: e.node.attributes,
    }),
  ),
});

const trackCartEvent = (event: SegmentEvent, cart: Cart): void => {
  try {
    logger.log({ event, cart }, 'tracking cart event');

    const properties = makeCartProperties(cart);

    trackEvent(event, properties);
  } catch (e: any) {
    logger.error({ event, cart }, 'error tracking cart event');
  }
};

export const trackCartViewed = (cart: Cart) =>
  trackCartEvent(SegmentEvent.CART_VIEWED, cart);
